import {html, LitElement} from 'lit';
import {customElement, state} from 'lit/decorators.js';
import {mapClick$} from '../../stores/store-map.ts';
import type {Subscription} from 'rxjs';
import {msg} from '@lit/localize';
import {crossSvg} from '../../helpers/elements.ts';
import {clearHighlight} from '../../proxies/proxy-highlight.ts';

@customElement('element-info-popup')
export default class ElementInfoPopup extends LitElement {
  @state() show: boolean = false;
  private mapClick: Subscription;

  setShow(show: boolean) {
    this.show = show;
  }

  override connectedCallback() {
    super.connectedCallback();
    this.mapClick = mapClick$.subscribe(() => {
      if (this.show) this.show = false;
    });
  }

  override disconnectedCallback() {
    this.mapClick.unsubscribe();
    super.disconnectedCallback();
  }

  override render() {
    return html`<div
      .hidden="${!this.show}"
      class="z-50 absolute right-[-30px] info-content w-auto bg-white px-[12px] py-[10px] text-body shadow-popup"
    >
      <div class="flex items-center justify-between">
        <span class="whitespace-nowrap pr-[10px]"
          >${msg('Click here for more information')}</span
        >
        <div
          class="mb-auto cursor-pointer"
          @click="${() => {
            this.show = false;
            clearHighlight(true);
          }}"
        >
          ${crossSvg(
            'h-[24px] w-[24-px] fill-chm-red mouse:hover:fill-chm-focus-red',
          )}
        </div>
      </div>
    </div>`;
  }

  override createRenderRoot() {
    return this;
  }
}
